import angular from 'angular'
import publishActionsComponent from './publishActions.component'
import publishActionsCalCtrl from './publishActionsCalCtrl.component'

export default angular
  .module('ellipsis.publishActions', [])
  .component('publishActions', publishActionsComponent)
  .component('publishActionsCalCtrl', publishActionsCalCtrl)
